import React, { useEffect } from 'react';
import $ from 'jquery';
import './App.css';
import Routeview from './router/index';
import routes from './router/config';
import lost from './images/页面走失.png';
import TitlePhone from './components/title/TitlePhone';
import {
  goBacks,
  hideTitle,
  isInMiniProgram,
  getUserInfoFromApp,
  getToken
} from './app/getUserInfoFromApp';
import { Provider as StoreProvider } from 'react-redux';
import store from './store/store';
import { Modal } from 'antd-mobile';
import { Helmet } from 'react-helmet';
import Vconsole from 'vconsole';
const alert = Modal.alert;
if (process.env.REACT_APP_ENV === 'test') {
  new Vconsole();
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // 更新 state 使下一次渲染能够显示降级后的 UI
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            width: '100%',
            backgroundColor: 'white',
            width: '100%',
            height: '100%',
          }}
        >
          <TitlePhone goBack={goBacks}></TitlePhone>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignContent: 'center',
              flexWrap: 'wrap',
              marginTop: '1rem',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                width: '90%',
              }}
            >
              <img src={lost} style={{ width: '100%', height: 'auto' }}></img>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div
                style={{
                  color: '#999999',
                  fontSize: '.3rem',
                  margin: '.5rem 0',
                }}
              >
                页面数据加载失败
              </div>
              <div
                onClick={() => location.reload()}
                style={{
                  width: '2rem',
                  height: '.8rem',
                  backgroundColor: '#4385F5',
                  borderRadius: '.4rem',
                  fontSize: '.35rem',
                  color: 'white',
                  lineHeight: '.8rem',
                }}
              >
                刷新
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return this.props.children;
    }
  }
}

//适配rem
function autoRem() {
  let windowWidth = $(window).width();
  let rem = (windowWidth / 750) * 100 + 'px';
  $('html').css({ fontSize: rem });
}
export const { Provider, Consumer } = React.createContext();
const pageShow = (event) => {
  if (
    event.persisted ||
    (window.performance && window.performance.navigation.type == 2)
  ) {
    hideTitle();
  }
  if (
    event.persisted &&
    process.env.REACT_APP_APP_BASE + '/enterpriseReplenishSuccess' ===
      window.location.pathname
  ) {
    window.location.reload();
  }
  if (
    event.persisted &&
    window.performance &&
    window.performance.navigation.type == 2 &&
    process.env.REACT_APP_APP_BASE + '/order' === window.location.pathname
  ) {
    window.location.reload();
  }
};
function App() {
  const path = window.location.pathname;
  useEffect(() => {
    autoRem();
    $(window).on('resize', autoRem);
    return () => {
      $(window).off('resize');
    };
  }, [autoRem]);

  useEffect(() => {
    window.addEventListener('pageshow', pageShow, false);
    getUserInfoFromApp().then((res) => {
      localStorage.setItem('userCode', res.userCode);
      localStorage.setItem('mobile', res.mobile);
    });
    getToken().then(res => {
      localStorage.setItem('token', res);
    })
    const isWx = isInMiniProgram();
    localStorage.setItem('isWx', isWx);
  }, []);
  return (
    <Provider value={path}>
      <StoreProvider store={store}>
        <div className="App">
          <ErrorBoundary>
            <Helmet>
              <meta
                name="viewport"
                content="viewport-fit=cover width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
              />
            </Helmet>
            <Routeview routes={routes} />
          </ErrorBoundary>
        </div>
      </StoreProvider>
    </Provider>
  );
}
export default App;
